import { Loader } from "lucide-react";
import { useLotteryWinningNumbers } from "../gameSlot/useGameSlot";
import { useEffect, useState } from "react";

const WinningNumbersContent = ({ game }: { game: any }) => {
  const { isLoading, error, lotteryWinningNumbers } =
    useLotteryWinningNumbers(game);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (lotteryWinningNumbers) {
      setData(lotteryWinningNumbers); // Ensure correct assignment
    }
  }, [lotteryWinningNumbers]);

  if (isLoading) return <Loader />;
  if (error)
    return <p className="text-red-500">Error loading winning numbers.</p>;
  console.log("Response from getWinningNumbers:", lotteryWinningNumbers);
  return (
    <div className="space-y-4">
      <div>
        <p className="font-medium">Winning Numbers:</p>
        <p className="text-md">
          {data?.targetNumbers?.length > 0
            ? data.targetNumbers.join(", ") 
            : "Game has not closed yet"}
        </p>
      </div>
      <div>
        <p className="font-medium">Closing Date:</p>
        <p>
          {Array.isArray(data?.date) 
            ? new Date(
                data.date[0],
                data.date[1] - 1,
                data.date[2],
                data.date[3],
                data.date[4],
                data.date[5]
              ).toLocaleDateString()
            : "N/A"}
        </p>
      </div>
      <div>
        <p className="font-medium">Prize Amount:</p>
        <p>
          ₦ {data?.amounttobewon ? data.amounttobewon.toLocaleString() : "N/A"}
        </p>
      </div>
    </div>
  );
};

export default WinningNumbersContent;
